var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStakedIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 129,
  height: 129,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.174,
  d: "M123.647 8.777 8.882 123.54"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2.174,
  d: "M116.383 29.511c6.739 9.975 10.674 22 10.674 34.944 0 34.517-27.983 62.5-62.5 62.5-12.577 0-24.285-3.715-34.089-10.107m-8.523-6.671C9.708 98.767 2.057 82.505 2.057 64.454c0-34.517 27.982-62.5 62.5-62.5 17.935 0 34.106 7.555 45.504 19.656"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M85.146 54.926c-.083 2.176-1.374 4.215-3.71 5.392l-4.353 2.183m-16.945 2.182-8.706-4.365c-3.93-1.948-4.904-6.364-2.144-9.806L61.433 35.38c2.76-3.475 7.306-3.475 10.034 0l7.947 9.928M66.466 32.945v17.08"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "m52.828 60.254 13.638-10.23 4.752 3.565M49.237 77.982c-.829-3.09 1.769-6.317 5.037-6.082m-.703 12.064 7.862 9.638c2.792 3.377 7.306 3.377 10.066 0l11.235-13.736c3.248-3.961-1.071-9.611-5.747-7.533l-5.228 2.338a13.02 13.02 0 0 1-8.506.714"
})));
export default SvgStakedIcon;